import { useEffect, useRef, useState, type ReactNode } from "react"
import Popover from "@/v2-ui/popover"
import SelectorContext, { type SearchStatus } from "./selector.context"

export type SelectorProps = {
  open?: boolean
  onOpenChange?(open: boolean): void
  shouldFilter?: boolean
  isLoading?: boolean
  /** When true, the dropdown content is portaled to `#mount` instead of rendering in place. */
  portal?: boolean
  children: ReactNode
}

function Selector(props: SelectorProps) {
  const {
    open,
    onOpenChange: onOpenChangeProp,
    shouldFilter = false,
    isLoading = false,
    portal = false,
    children,
  } = props

  const [_isLoading, setIsLoading] = useState(isLoading ?? false)
  const [isOpen, setIsOpen] = useState(open ?? false)
  const [searchStatus, setSearchStatus] = useState<SearchStatus>("idle")
  const minSearchLengthRef = useRef(0)

  useEffect(() => {
    if (open !== undefined) {
      setIsOpen(open)
    }
  }, [open])

  return (
    <SelectorContext.Provider
      value={{
        shouldFilter,
        isLoading: _isLoading,
        setIsLoading,
        portal,
        searchStatus,
        setSearchStatus,
        minSearchLengthRef,
      }}
    >
      <Popover
        open={isOpen}
        onOpenChange={(open) => {
          setIsOpen(open)
          onOpenChangeProp?.(open)
        }}
      >
        {children}
      </Popover>
    </SelectorContext.Provider>
  )
}

export default Selector
